import { filter } from "lodash";
import { useEffect, useState } from "react";

import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  Avatar,
  Checkbox,
  Chip,
  TextField,
  Pagination,
  Button,
} from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import SearchNotFound from "src/components/NotFound/SearchNotFound";
import { UserListToolbar } from "src/components/_dashboard/user";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";
import TableFooter from "@mui/material/TableFooter";

import MuiTableHeadList from "./MuiTableHeadList";
import UserListToolbarsForSearch from "./_dashboard/user/UserListToolbarsForSearch";
import Label from "./Label";
// import UserListToolbarsForSearch from "./UserListToolbarsForSearch";
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// ---- Opt-in sorting (`sortable` prop) --------------------------------------
// A column sorts by `head.sortValue(row)` when given, otherwise by `row[head.id]`
// when that is a plain value (string / number / boolean / Date). Columns whose
// value is a React element (renderData-only) are left unsorted unless they
// provide `sortValue`. Action / checkbox columns, and `sortable: false`
// columns, never sort.
const NON_SORTABLE_TYPES = ["action", "checkbox", "row_calendar", "thumbnail"];

const isSortableHead = (head) =>
  Boolean(head) &&
  head.sortable !== false &&
  !NON_SORTABLE_TYPES.includes(head.type);

const plainSortValue = (value) => {
  if (value === null || value === undefined || value === "") return null;
  if (value instanceof Date) return value.getTime();
  if (typeof value === "number") return value;
  if (typeof value === "boolean") return value ? 1 : 0;
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return null;
    // ISO dates sort as dates; everything else case-insensitive text.
    if (/^\d{4}-\d{2}-\d{2}/.test(trimmed)) {
      const time = Date.parse(trimmed);
      if (!Number.isNaN(time)) return time;
    }
    return trimmed.toLowerCase();
  }
  return null; // objects / React elements are not comparable
};

const sortValueFor = (row, head) => {
  if (!head) return null;
  if (typeof head.sortValue === "function") {
    return plainSortValue(head.sortValue(row));
  }
  return plainSortValue(row?.[head.id]);
};

const compareSortValues = (a, b) => {
  // Empty values always go last, whatever the direction.
  if (a === null && b === null) return 0;
  if (a === null) return 1;
  if (b === null) return -1;
  if (typeof a === "number" && typeof b === "number") return a - b;
  return String(a).localeCompare(String(b), undefined, { numeric: true });
};

export default function CustomMUITable({
  TABLE_HEAD,
  data,
  MENU_OPTIONS,
  checkbox_selection,
  type,
  selected,
  setSelected,
  selected_by,
  className,
  custom_pagination,
  sortBy,
  custom_search,
  pageCount,
  totalPages,
  handleChangePages,
  pagePagination,
  rows_per_page_count,
  show_extra_button,
  hide_search,
  // Optional: called with (row, index) when a row is clicked. Clicks on
  // buttons, links, inputs, checkboxes and the action menu are ignored.
  onRowClick,
  // Optional: turn on column sorting (see sortValueFor above).
  sortable,
}) {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState(sortBy ? sortBy : "number");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(
    custom_pagination?.rows_per_page
      ? custom_pagination?.rows_per_page
      : rows_per_page_count
      ? rows_per_page_count
      : 50
  );
  const handleRequestSort = (event, property) => {
    if (!sortable) return;
    const head = (TABLE_HEAD || []).find((item) => item.id === property);
    if (!isSortableHead(head)) return;
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setPage(0);
  };

  // If the data shrinks (e.g. a filter is applied while on page 2) and the
  // current page is now past the end, go back to the first page instead of
  // showing an empty table.
  const dataLength = Array.isArray(data) ? data.length : 0;
  useEffect(() => {
    if (custom_pagination) return;
    if (page > 0 && page * rowsPerPage >= dataLength) {
      setPage(0);
    }
  }, [dataLength, rowsPerPage, page, custom_pagination]);

  const isRowClickIgnored = (event) => {
    const target = event?.target;
    if (!target || typeof target.closest !== "function") return false;
    return Boolean(
      target.closest(
        "button, a, input, textarea, select, label, [role='button'], [role='menuitem'], [role='checkbox'], [role='combobox'], .MuiCheckbox-root, .MuiSwitch-root, .custom-popover-icon, .menu-background-circle, [data-row-click='ignore']"
      )
    );
  };

  const handleRowClick = (event, row, index) => {
    if (!onRowClick || isRowClickIgnored(event)) return;
    onRowClick(row, index);
  };

  if (checkbox_selection && !selected) {
    console.log(
      "Error : selected paramter is required as select array AND setSelected paramter is required as setter function for select array"
    );
    selected = [];
  }

  const handleClick = (name) => {
    console.log(name, "nameeeeeeeeeeeeeeeeeeeeee");
    if (name.disable) {
    } else {
      const selectedIndex = selected?.some((obj) => {
        if (selected_by && selected_by !== "") {
          return obj[selected_by] === name[selected_by];
        } else {
          return obj._id === name._id;
        }
      });

      if (selectedIndex === true) {
        let new_array = selected.filter((item) => {
          if (selected_by && selected_by !== "") {
            return item[selected_by] !== name[selected_by];
          } else {
            return item._id !== name._id;
          }
        });
        setSelected(new_array);
      } else {
        setSelected((selected) => [...selected, name]);
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function applySortFilter(array, comparator, query) {
    if (sortable) {
      return applyOptInSort(array, query);
    }
    if (!custom_pagination?.rows_per_page) {
      // if not using custom_pagination from database then use this line for pagination
      array = array.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    }
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    if (query) {
      return filter(array, (_user) => {
        let searched_object = TABLE_HEAD.some((item) => {
          if (
            item.type !== "link" &&
            item.type !== "row_status" &&
            item.type !== "checkbox" &&
            item.type !== "row_calendar" &&
            item.type !== "thumbnail" &&
            item.type !== "action" &&
            item.type !== "category" &&
            !item.renderData &&
            item.type !== "number"
          ) {
            return (
              _user[item.id]
                ?.toString()
                .toLowerCase()
                .indexOf(query.toLowerCase()) !== -1
            );
          }
        });
        return searched_object;
      });
    }
    return stabilizedThis.map((el) => el[0]);
  }

  // Sortable tables: sort the whole list first, then take the current page
  // (the legacy path above pages first, so it can only sort within a page).
  function applyOptInSort(array, query) {
    let list = Array.isArray(array) ? array.slice() : [];
    if (query) {
      const q = query.toLowerCase();
      list = list.filter((row) =>
        (TABLE_HEAD || []).some((item) => {
          const value = sortValueFor(row, item);
          return value !== null && String(value).toLowerCase().includes(q);
        })
      );
    }
    const head = (TABLE_HEAD || []).find((item) => item.id === orderBy);
    const indexed = list.map((row, index) => [row, index]);
    if (orderBy === "number" || head?.type === "number") {
      // "#" keeps the order the page gave us; desc just reverses it.
      if (order === "desc") indexed.reverse();
    } else if (isSortableHead(head)) {
      indexed.sort((a, b) => {
        const result = compareSortValues(
          sortValueFor(a[0], head),
          sortValueFor(b[0], head)
        );
        if (result !== 0) {
          // Empty values stay last in both directions.
          const aEmpty = sortValueFor(a[0], head) === null;
          const bEmpty = sortValueFor(b[0], head) === null;
          if (aEmpty || bEmpty) return result;
          return order === "desc" ? -result : result;
        }
        return a[1] - b[1];
      });
    }
    const sorted = indexed.map((pair) => pair[0]);
    if (custom_pagination?.rows_per_page) return sorted;
    return sorted.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleSearchText = (event) => {
    custom_search.setSearchText(event.target.value);
  };

  const filteredUsers = applySortFilter(
    data,
    getComparator(order, orderBy),
    filterName.trim()
  );

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setSelected(data);
      return;
    }
    const nonDisabledItems = data.filter((item) => item.disable);
    setSelected(nonDisabledItems);
  };

  const isUserNotFound = filteredUsers.length === 0;
  return (
    <Card
      style={{ overflowX: "auto" }}
      className={`mui-without-bg-custom-table ${className}`}
    >
      {custom_search ? (
        <>
          <div className="d-flex justify-content-between">
            {pagePagination && (
              <div className="d-flex flex-column align-items-start">
                <TablePagination
                  rowsPerPageOptions={[10, 50, 100, 200, 500]}
                  onRowsPerPageChange={
                    custom_pagination
                      ? custom_pagination.onRowsPerPageChange
                      : handleChangeRowsPerPage
                  }
                  component="div"
                  className="pt-3"
                  count={
                    custom_pagination
                      ? custom_pagination.total_count
                      : data.length
                  }
                  rowsPerPage={
                    custom_pagination
                      ? custom_pagination?.rows_per_page
                      : rowsPerPage
                  }
                  page={custom_pagination ? custom_pagination.page : page}
                  onPageChange={
                    custom_pagination
                      ? custom_pagination.handleChangePage
                      : handleChangePage
                  }
                />
                <Pagination
                  count={totalPages + 1}
                  page={pageCount}
                  defaultPage={0}
                  onChange={handleChangePages}
                  className="pagination-style"
                />
              </div>
            )}
            <div className="d-flex align-items-center">
              {show_extra_button && show_extra_button?.isShow && (
                <Button
                  variant="outlined"
                  style={{
                    height: 40,
                  }}
                  onClick={show_extra_button?.handleClick}
                >
                  {show_extra_button?.title}
                </Button>
              )}
              <UserListToolbarsForSearch
                filterName={custom_search.searchText}
                onFilterName={handleSearchText}
                handleSubmit={custom_search.handleSubmit}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          {(pagePagination || !hide_search) && (
            <div
              className={`${
                pagePagination ? "d-flex justify-content-between" : "text-end"
              }`}
            >
              {pagePagination && (
                <div className="d-flex flex-column align-items-start">
                  <TablePagination
                    rowsPerPageOptions={[10, 50, 100, 200, 500]}
                    onRowsPerPageChange={
                      custom_pagination
                        ? custom_pagination.onRowsPerPageChange
                        : handleChangeRowsPerPage
                    }
                    component="div"
                    count={
                      custom_pagination
                        ? custom_pagination.total_count
                        : data.length
                    }
                    rowsPerPage={
                      custom_pagination
                        ? custom_pagination?.rows_per_page
                        : rowsPerPage
                    }
                    page={custom_pagination ? custom_pagination.page : page}
                    onPageChange={
                      custom_pagination
                        ? custom_pagination.handleChangePage
                        : handleChangePage
                    }
                  />
                  {pageCount && (
                    <Pagination
                      count={totalPages + 1}
                      page={pageCount}
                      defaultPage={0}
                      onChange={handleChangePages}
                      className="pagination-style"
                    />
                  )}
                </div>
              )}
              {!hide_search && (
                <UserListToolbar
                  filterName={filterName}
                  onFilterName={handleFilterByName}
                />
              )}
            </div>
          )}
        </>
      )}

      <TableContainer sx={{ minWidth: 800 }}>
        <Table>
          <MuiTableHeadList
            order={order}
            orderBy={orderBy}
            headLabel={TABLE_HEAD}
            rowCount={data.length}
            numSelected={checkbox_selection && selected.length}
            onRequestSort={handleRequestSort}
            checkbox_selection={checkbox_selection}
            handleSelectAllClick={handleSelectAllClick}
          />
          <TableBody>
            {filteredUsers.map((row, index) => {
              const isItemSelected =
                selected?.length < 1
                  ? false
                  : selected?.some((obj) => {
                      if (selected_by && selected_by !== "") {
                        return obj[selected_by] === row[selected_by];
                      } else {
                        return obj._id === row._id;
                      }
                    });
              let enableDisable =
                selected?.length < 1
                  ? false
                  : selected?.some((obj) => {
                      return obj.disable;

                      {
                        /* if () {
                        return obj[selected_by] === row[selected_by];
                      } else {
                        return obj._id === row._id;
                      } */
                      }
                    });
              return (
                <TableRow
                  hover
                  key={index}
                  tabIndex={-1}
                  role="checkbox"
                  selected={isItemSelected}
                  aria-checked={isItemSelected}
                  onClick={
                    onRowClick
                      ? (event) => handleRowClick(event, row, index)
                      : undefined
                  }
                  style={onRowClick ? { cursor: "pointer" } : undefined}
                >
                  {checkbox_selection && (
                    <TableCell align="left" width={50}>
                      {type == "add" ? (
                        <Checkbox
                          checked={isItemSelected}
                          onChange={() => handleClick(row)}
                        />
                      ) : (
                        <Checkbox
                          checked={isItemSelected}
                          onChange={() => handleClick(row)}
                        />
                      )}
                    </TableCell>
                  )}
                  {TABLE_HEAD.map((head, i) => {
                    if (head.type === "action") {
                      return (
                        <TableCell
                          data-row-click="ignore"
                          align="left"
                          className={
                            head.className
                              ? head.className
                              : "action-in-table-width"
                          }
                          key={i}
                        >
                          {(row[head.MENU_OPTIONS]?.length > 0 ||
                            MENU_OPTIONS?.length > 0) && (
                            <CustomPopoverSection
                              menu={
                                row[head.MENU_OPTIONS]
                                  ? row[head.MENU_OPTIONS]
                                  : MENU_OPTIONS
                              }
                              data={row}
                            />
                          )}
                        </TableCell>
                      );
                    } else if (head.type === "checkbox") {
                      return (
                        <TableCell
                          className={head.className}
                          align="left"
                          key={i}
                        >
                          <Checkbox
                            checked={row[head.id]}
                            onChange={(e) => head.handleClick(e, row, index)}
                          />
                        </TableCell>
                      );
                    } else if (head.type === "row_calendar") {
                      if (row.is_show_celendar === true) {
                        return (
                          <TableCell
                            className={head.className}
                            align="left"
                            key={i}
                          >
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DesktopDatePicker
                                inputFormat="dd-MM-yyyy"
                                onChange={(date) =>
                                  head.handleChangeDate(date, index, row)
                                }
                                value={row[head.id]}
                                renderInput={(params) => (
                                  <TextField {...params} size="small" />
                                )}
                              />
                            </LocalizationProvider>
                          </TableCell>
                        );
                      } else {
                        return <TableCell align="left" key={i}></TableCell>;
                      }
                    } else if (head.type === "number") {
                      return (
                        <TableCell
                          className={
                            head.className
                              ? head.className
                              : "action-in-table-width"
                          }
                          align="left"
                          key={i}
                        >
                          <span
                            className={row.className}
                            onClick={() => {
                              if (head.handleClick) head.handleClick(row, index);
                            }}
                          >
                            {index +
                              1 +
                              (custom_pagination
                                ? custom_pagination?.rows_per_page *
                                  custom_pagination?.page
                                : rowsPerPage * page)}
                          </span>
                        </TableCell>
                      );
                    } else if (head.type === "row_status") {
                      return (
                        <TableCell
                          className={head.className}
                          align="left"
                          key={i}
                        >
                          <Label
                            sx={{
                              width: 85,
                              minWidth: 85,
                              textAlign: "center",
                            }}
                            variant="ghost"
                            color={row[head.id] === false ? "error" : "success"}
                          >
                            {row[head.id] === false ? "InActive" : "Active"}
                          </Label>
                        </TableCell>
                      );
                    } else if (head.type === "thumbnail") {
                      return (
                        <TableCell
                          className={head.className}
                          align="left"
                          key={i}
                        >
                          <Avatar
                            alt={row[head.id]?.alt}
                            src={row[head.id]?.src}
                          />
                        </TableCell>
                      );
                    } else if (head.type === "link") {
                      return (
                        <TableCell className={head.className} key={i}>
                          {row[head.id].show_text ? (
                            <a
                              href={row[head.id].to}
                              className={row[head.id].className}
                              target={row[head.id].target}
                            >
                              {row[head.id].show_text}
                            </a>
                          ) : row[head.id].show_alternate_text ? (
                            row[head.id].show_alternate_text
                          ) : (
                            ""
                          )}
                        </TableCell>
                      );
                    } else if (head.type === "html") {
                      return (
                        <TableCell
                          align="left"
                          component="th"
                          scope="row"
                          className={head.className}
                          key={i}
                        >
                          <div
                            className={row.className}
                            dangerouslySetInnerHTML={{
                              __html: row[head.id],
                            }}
                          ></div>
                        </TableCell>
                      );
                    } else {
                      return (
                        <TableCell
                          align="left"
                          className={head.className}
                          key={i}
                        >
                          {head.renderData ? (
                            head.renderData(row)
                          ) : (
                            <span
                              className={row.className}
                              onClick={() => {
                                if (head.handleClick) head.handleClick(row, index);
                              }}
                            >
                              {row[head.id]}
                            </span>
                          )}
                        </TableCell>
                      );
                    }
                  })}
                </TableRow>
              );
            })}
          </TableBody>
          {isUserNotFound && (
            <TableBody>
              <TableRow>
                <TableCell
                  align="center"
                  colSpan={
                    checkbox_selection
                      ? TABLE_HEAD.length + 1
                      : TABLE_HEAD.length
                  }
                  sx={{ py: 3 }}
                >
                  <SearchNotFound searchQuery={filterName} />
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <TableFooter className="mui-table-footer mt-2">
        <div className="mt-2"></div>
        {/* <div className="rows_selected_text">
          {checkbox_selection && selected.length > 0
            ? `${selected.length} ${
                selected.length > 1 ? "rows" : "row"
              } selected`
            : ""}
        </div> */}
        <TablePagination
          rowsPerPageOptions={[10, 50, 100, 200, 500]}
          onRowsPerPageChange={
            custom_pagination
              ? custom_pagination.onRowsPerPageChange
              : handleChangeRowsPerPage
          }
          component="div"
          count={
            custom_pagination ? custom_pagination.total_count : data.length
          }
          rowsPerPage={
            custom_pagination ? custom_pagination?.rows_per_page : rowsPerPage
          }
          page={custom_pagination ? custom_pagination.page : page}
          onPageChange={
            custom_pagination
              ? custom_pagination.handleChangePage
              : handleChangePage
          }
        />
      </TableFooter>
      {pagePagination && pageCount ? (
        <Pagination
          count={totalPages + 1}
          page={pageCount}
          defaultPage={0}
          onChange={handleChangePages}
          className="pagination-style"
        />
      ) : (
        ""
      )}
    </Card>
  );
}
